import { Button } from "@/components/ui/button";
import { useList } from "@/features/license-fee/list/context/use-list";
import { LicenseFeeTable } from "@/features/license-fee/list/layouts/list-table/list-table";
import { PageBreadcrumb } from "@/layouts/page-container/shared/breadcrumb";
import { PlusIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import { DEFAULT_ROUTES } from "@/constants/routes";
import { Skeleton } from "@/components/ui/skeleton";
import { Pagination } from "@/features/pagination/layouts/pagination";
import { FiltersLicenseFees } from "@/features/license-fee/list/layouts/filters-license-fees/filters-license-fees";

export const LicenseFeeList = () => {
  const {
    data,
    isLoading,
    pagination,
    activePage,
    handleChangePage,
    decreasePage,
    increasePage,
    totalPages,
  } = useList();

  return (
    <>
      <PageBreadcrumb>
        <Button className="ml-auto" disabled={isLoading}>
          <Link
            to={DEFAULT_ROUTES.LICENSE_FEE_CREATE}
            className="flex items-center gap-2"
          >
            <PlusIcon className="w-5" />
            Criar License Fee
          </Link>
        </Button>
      </PageBreadcrumb>

      <FiltersLicenseFees />

      <div>
        <LicenseFeeTable data={data} isLoading={isLoading} />

        {isLoading ? (
          <div className="flex w-full justify-end m-4">
            <Skeleton className="w-[371px] h-[36px] rounded-full" />
          </div>
        ) : (
          data?.length > 0 && (
            <Pagination
              count={1000}
              page={activePage}
              onPageClick={handleChangePage}
              onPrevPageClick={decreasePage}
              onNextPageClick={increasePage}
              pageName="License Fees"
              totalLines={`${pagination.total}`}
              totalPages={totalPages || 1}
            />
          )
        )}
      </div>
    </>
  );
};
